import { restApi } from "@/api/index";
/**
 * @typedef UserSettings
 * @type {object}
 * @property {number?} distance - the distance in kilometers.
 * @property {number?} min_age - the minimum age of users to show.
 * @property {number?} max_age - the maximum age of users to show.
 * @property {boolean?} adjust_age - whether to adjust the age of users.
 * @property {boolean?} adjust_distance - whether to adjust the distance of users.
 * @property {boolean?} only_community - whether to show only community users.
 * @property {boolean?} isDefined - whether the settings are defined.
 */

export const getSettings = () => {
  return restApi.get(`/user/settings`);
};

/**
 * Updates the user settings
 * @param {UserSettings} data - The data to update the settings with
 * @returns {Promise<{settings: UserSettings}>} Promise representing the API response
 */
export const updateSettings = (data) => {
  return restApi.post(`/user/settings`, data);
};

export const resetSettings = () => {
  return restApi.delete(`/user/settings`);
};
